import React from "react";
import Modal from "react-modal";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { useAuth } from "../../context/AuthContext";
import logoImg from "../../assets/logo2.png";

const traduzirStatus = (status) => {
  switch (status) {
    case "paid":
      return "Pago";
    case "pending":
      return "Pendente";
    case "overdue":
      return "Em atraso";
    default:
      return status || "—";
  }
};

const gerarRecibo = (pagamento, operador = "Operador desconhecido") => {
  if (!pagamento) return;

  const doc = new jsPDF();

  const nomeEscola = "Escola Vida Abundante";
  const emailEscola = "escolavidaabundante@gmail.com";
  const localizacao = "Matola, Machava Km 15 Nkomane";
  const nuit = "700067254";
  const desenvolvedor = "Chaúcá Creative";

  // 🔹 Corrigir proporção do logo
  const img = new Image();
  img.src = logoImg;

  img.onload = () => {
    const maxWidth = 40; // largura máxima permitida
    const scale = maxWidth / img.width;
    const imgWidth = maxWidth;
    const imgHeight = img.height * scale;

    doc.addImage(img, "PNG", 10, 10, imgWidth, imgHeight);

    // Cabeçalhos
    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.text("ACADE – Gestor Escolar", 60, 15);

    doc.setFont("helvetica", "italic");
    doc.setFontSize(12);
    doc.text("Recibo de Pagamento", 60, 23);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.text(nomeEscola, 60, 30);
    doc.text(`Email: ${emailEscola}`, 60, 36);
    doc.text(`Localização: ${localizacao}`, 60, 42);
    doc.text(`NUIT: ${nuit}`, 60, 48);

    // Cabeçalho à direita
    const now = new Date().toLocaleString("pt-AO");
    doc.text(`Data: ${now}`, 200, 20, { align: "right" });
    doc.text(`Operador: ${operador}`, 200, 26, { align: "right" });
    doc.text(
      `Recibo Nº: ${pagamento?.numero_recibo ?? "—"}`,
      200,
      32,
      { align: "right" }
    );

    // Tabela com dados do pagamento
    const colunas = ["Campo", "Detalhes"];
    const dados = [
      ["Aluno", pagamento?.student || "—"],
      ["Código do Aluno", pagamento?.code || "—"],
      ["Classe", pagamento?.class || "—"],
      ["Entidade", pagamento?.entity || "—"],
      ["Referência", pagamento?.reference || "—"],
      ["Tipo de Serviço", (pagamento?.type || "—").toUpperCase()],
      ["Forma de Pagamento", pagamento?.paymentMethod || "—"],
      ["Valor", `${parseFloat(pagamento?.amount).toFixed(2)} MZN`],
      ["Data/Hora", pagamento?.datetime || "—"],
      ["Estado", traduzirStatus(pagamento?.status)],
    ];

    autoTable(doc, {
      head: [colunas],
      body: dados,
      startY: 55,
      styles: { fontSize: 11, cellPadding: 4 },
      headStyles: {
        fillColor: [22, 160, 133],
        textColor: 255,
        halign: "center",
      },
      columnStyles: {
        0: { cellWidth: 60, fontStyle: "bold" },
        1: { cellWidth: 120 },
      },
    });

    // Rodapé
    const pageHeight = doc.internal.pageSize.height;
    const pageWidth = doc.internal.pageSize.width;
    const pageNumber = doc.internal.getNumberOfPages();

    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.text(
      `Software: ACADE-Gestor Escolar | Processado por computador. Página ${pageNumber} de ${pageNumber}.`,
      14,
      pageHeight - 15
    );

    doc.setDrawColor(150);
    doc.line(14, pageHeight - 13, pageWidth - 14, pageHeight - 13);

    doc.setFont("helvetica", "italic");
    doc.text(`Desenvolvido por ${desenvolvedor}`, pageWidth - 14, pageHeight - 8, {
      align: "right",
    });

    // Salvar arquivo
    const nomeArquivo = `recibo_${pagamento?.code || pagamento?.numero_recibo || "pagamento"}.pdf`;
    doc.save(nomeArquivo);
  };
};

const Recibo = ({ pagamento, onClose }) => {
  const { user } = useAuth();
  const operadorEmail = user?.email || "Operador desconhecido";

  if (!pagamento) return null;

  return (
    <Modal
      isOpen={true}
      onRequestClose={onClose}
      style={{
        overlay: {
          backgroundColor: "rgba(0,0,0,0.5)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9999,
        },
        content: {
          inset: "unset",
          padding: "30px 40px",
          background: "#fff",
          borderRadius: "12px",
          maxWidth: "700px",
          width: "90%",
          maxHeight: "90vh",
          overflowY: "auto",
        },
      }}
      ariaHideApp={false}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "15px",
          marginBottom: "20px",
          borderBottom: "2px solid #16a085",
          paddingBottom: "10px",
        }}
      >
        <img src={logoImg} alt="Logo Escola" style={{ width: 80 }} />
        <h2 style={{ margin: 0, color: "#16a085", fontWeight: "bold" }}>
          Recibo de Pagamento
        </h2>
      </div>

      <div style={{ flexGrow: 1 }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <tbody>
            {[
              ["Aluno", pagamento?.student || "—"],
              ["Código do Aluno", pagamento?.code || "—"],
              ["Classe", pagamento?.class || "—"],
              ["Entidade", pagamento?.entity || "—"],
              ["Referência", pagamento?.reference || "—"],
              ["Tipo de Serviço", (pagamento?.type || "—").toUpperCase()],
              ["Forma de Pagamento", pagamento?.paymentMethod || "—"],
              ["Valor", `${parseFloat(pagamento?.amount).toFixed(2)} MZN`],
              ["Data/Hora", pagamento?.datetime || "—"],
              ["Estado", traduzirStatus(pagamento?.status)],
              ["Operador", operadorEmail],
            ].map(([label, value]) => (
              <tr key={label} style={{ borderBottom: "1px solid #ddd" }}>
                <td
                  style={{
                    padding: "8px 10px",
                    fontWeight: "600",
                    color: "#333",
                    width: "35%",
                  }}
                >
                  {label}
                </td>
                <td style={{ padding: "8px 10px", color: "#555" }}>
                  {value || "—"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div
        style={{
          marginTop: 20,
          display: "flex",
          justifyContent: "flex-end",
          gap: "12px",
        }}
      >
        <button
          onClick={() => gerarRecibo(pagamento, operadorEmail)}
          style={{
            backgroundColor: "#16a085",
            color: "white",
            border: "none",
            padding: "10px 16px",
            borderRadius: "6px",
            cursor: "pointer",
            fontWeight: "600",
          }}
        >
          Exportar PDF
        </button>
        <button
          onClick={onClose}
          style={{
            backgroundColor: "#c0392b",
            color: "white",
            border: "none",
            padding: "10px 16px",
            borderRadius: "6px",
            cursor: "pointer",
            fontWeight: "600",
          }}
        >
          Fechar
        </button>
      </div>
    </Modal>
  );
};

export default Recibo;
export { gerarRecibo };
